import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Utils } from "../../../Utils";
import { Button, Col, Dropdown, Row } from "react-bootstrap";
import { FaCalendarAlt, FaChevronDown } from 'react-icons/fa';
import { AiOutlineThunderbolt } from "react-icons/ai";
import { PiSlidersHorizontal } from "react-icons/pi";
import { HiOutlineCog6Tooth } from "react-icons/hi2";
import triangleIcon from '../../../Assets/images/icons/triangle-left.svg';
import { ReactComponent as DefaultFilterViewIcon } from '../../../Assets/images/icons/default-filter-view-icon.svg';
import { ReactComponent as PeopleAutoScoreIcon } from '../../../Assets/images/icons/people-auto-score-icon.svg';
import Sidebar from "./sidebar";
import Filters from "./filters";
import SelectedFilters from "./selectedFilters";
import CompanyTableData from "./companyTableData";
import ContactTableData from "./contactTableData";
import QuickFilters from "./QuickFilters";
import { useDispatch, useSelector } from "react-redux";
import { deleteSavedScrapperStart, getMobileAccessStart, getRecentSaveStart, getRecentSearchStart, getSavedScrapperStart, getScrapperStart, resetCreateState, resetDeleteState, resetProspectState, saveProspectStart, saveScrapperStart } from "../../../Store/Slices/scrapperSlice";
import Loader from "../../../Components/Loader";
import RecentSearchData from "./recentFilters";
import { IoMdAdd } from "react-icons/io";
import SavedTableData from "./savedTableData";
import { toast } from "react-toastify";
import Toast from "../../../Components/Toast";
import { FaMinus } from "react-icons/fa6";
import { TbPhoneCheck } from "react-icons/tb";
import { LuShare } from "react-icons/lu";
import { getItem } from "../../../Services/localService";

const DataVault = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let formList = useSelector((state) => state?.forms);
    let currentUserData = getItem('user');
    const [searchValue, setSearchValue] = useState('');
    let scrapperData = useSelector((state) => state.scrapper);
    let subFormData = useSelector((state) => (state?.subForm || ''));
    let [selectedOption, setSelectedOption] = useState();
    let [selectedItems, setSelectedItems] = useState([]);
    let [isShowMatchingContacts, setIsShowMatchingContacts] = useState(true);
    let [showFilterData, setShowFilterData] = useState(false)

    let [isInitial, setIsInitial] = useState(true)
    let [selectedTab, setSelectedtab] = useState('total')
    let [savedTableAction, setSavedTableAction] = useState('')

    const handleClearAll = () => { setSelectedItems([]) }

    const handleRemove = (id) => {
        setSelectedItems((prevData) => prevData.filter((item) => item.id !== id));
    };

    // Filter section show/hide toggle functionality
    const [showFilterSection, setShowFilterSection] = useState(true);

    let [filterObj, setFilterObj] = useState({
        "contact_email_status_v2": [],
        "fields": ["email", "first_name", "last_name", "phone_numbers"],
        "q_keywords": "",
        "person_titles": [],
        "organization_domains": [],
        "person_locations": [],
        "include_similar_titles": true,
        "organization_ids": [],
        "keywords": [],
        "q_organization_keyword_tags": [],
        "organization_num_employees_ranges": [],
        "name_search": ""
    })
    let [currentPage, setCurrentPage] = useState(1);
    let [pageSize, setPageSize] = useState(10);
    let [paginationActivate, setPaginationActivate] = useState(false);
    // saved collection table
    let [currentPageS, setCurrentPageS] = useState(1);
    let [pageSizeS, setPageSizeS] = useState(10);
    let [paginationActivateS, setPaginationActivateS] = useState(false);

    let [selectedDataToSave, setSelectedDataToSave] = useState([]);
    let [selectedDataToUnsave, setSelectedDataToUnsave] = useState([]);

    let [accessDataList, setAccessDataList] = useState([]);
    let [prospectModuleId, setProspectModuleId] = useState("");
    let [mode, setMode] = useState('delete')

    useEffect(() => {
        dispatch(getSavedScrapperStart({ page: currentPage, count: pageSize }));
        dispatch(getRecentSaveStart());
        dispatch(getRecentSearchStart());
    }, [])

    useEffect(() => {
        if (formList?.navbarList?.length > 0) {
            let module_id = formList?.navbarList.find(item => item.name === "Prospects")?._id;
            setProspectModuleId(module_id);
        }
    }, [formList])

    useEffect(() => {
        setSelectedDataToSave([]);
        setSelectedDataToUnsave([]);
    }, [selectedTab])

    const removeKeys = (obj, keysToRemove) => {
        return Object.fromEntries(
            Object.entries(obj).filter(([key]) => !keysToRemove.includes(key))
        );
    };

    useEffect(() => {
        if (paginationActivate) {
            let orgIds = filterObj?.organization_ids
            let orglocations = filterObj?.person_locations
            let orgEmailStatus = filterObj?.contact_email_status_v2

            const keysToDelete = ["organization_ids", "person_locations", "keywords", "contact_email_status_v2"];
            const updated = removeKeys(filterObj, keysToDelete);
            updated['organization_ids'] = orgIds?.map((x) => x.id)
            updated['person_locations'] = orglocations?.map((x) => x.value)
            updated['page'] = currentPage
            updated['per_page'] = pageSize
            updated['organization_names'] = orgIds?.map((x) => x.label)
            updated['contact_email_status_v2'] = orgEmailStatus?.map((x) => x.value)
            setIsInitial(false);
            console.log('PAYLOAD FROM PAGINATION:', updated)
            dispatch(getScrapperStart(updated))
        }
    }, [paginationActivate, pageSize, currentPage])

    useEffect(() => {
        if (paginationActivateS) {
            dispatch(getSavedScrapperStart({ page: currentPageS, count: pageSizeS }));
        }
    }, [paginationActivateS, pageSizeS, currentPageS])

    const saveFilterData = () => {
        const updatedData = selectedDataToSave.map(item => ({
            ...item,
            person_id: item.id
        }));

        let payload = {
            data: updatedData
        }

        dispatch(saveScrapperStart(payload))
    }

    const unsaveFilterData = () => {
        let payload = {
            searchIds: selectedDataToUnsave?.map((data) => data?._id)
        }
        dispatch(deleteSavedScrapperStart(payload))
    }

    const getAccessMobile = () => {
        const filteredArray = selectedDataToUnsave.map(item => ({
            "first_name": item?.first_name,
            "last_name": item?.last_name,
            "organization_name": item?.organization?.name,
            "person_id": item?.person_id
        }));

        let payload = {
            data: filteredArray
        }
        dispatch(getMobileAccessStart(payload))
    }

    useEffect(() => {
        if (scrapperData?.accessData) {
            // const newItem = {
            //     id: scrapperData?.accessData?.[0]?.person_id,
            //     email: scrapperData?.accessData?.[0]?.email,
            //     phone: scrapperData?.accessData?.[0]?.phone
            // };

            // scrapperData?.accessData.forEach(item => {
            //     setAccessDataList(prevItems => {
            //         const alreadyExists = prevItems.some(item => item.id === item?.person_id);
            //         if (!alreadyExists) {
            //             return [...prevItems, item];
            //         }
            //         return prevItems;
            //     });
            // });

            // setAccessDataList(prevItems => [...prevItems, newItem]);

            const updatedArray = [...accessDataList];

            scrapperData?.accessData.forEach((newObj) => {
                const exists = accessDataList.some((item) => item.person_id === newObj.person_id);
                if (!exists) {
                    updatedArray.push(newObj);
                }
            });

            setAccessDataList(updatedArray);
        }
    }, [scrapperData])

    useEffect(() => {
        if (scrapperData?.prospectStatus) {
            setSelectedDataToUnsave([])
            setAccessDataList([])
            dispatch(resetProspectState())
            setMode('move')
            unsaveFilterData()
        }
        if (scrapperData?.createStatus) {
            toast.success(scrapperData?.message, {
                autoClose: 1000,
                onClose: () => {
                    setSelectedDataToSave([])
                    dispatch(resetCreateState())
                    dispatch(getRecentSaveStart());
                    dispatch(getSavedScrapperStart({ page: currentPage, count: pageSize }));
                }
            })
        }
        if (scrapperData?.deleteStatus) {
            let msg = mode === 'delete' ? scrapperData?.message : 'Searches moved successfully'
            toast.success(msg, {
                autoClose: 1000,
                onClose: () => {
                    setSelectedDataToUnsave([])
                    dispatch(resetDeleteState())
                    dispatch(getRecentSaveStart());
                    dispatch(getSavedScrapperStart({ page: currentPageS, count: pageSizeS }));
                }
            })
        }
    }, [scrapperData?.createStatus, scrapperData?.deleteStatus, scrapperData?.prospectStatus])

    const handleMove = () => {
        if (!selectedDataToUnsave || selectedDataToUnsave.length === 0) {
            toast.error("Please get the email access for all selected records before moving", {
                autoClose: 2000
            })
            return;
        }

        const allValid = selectedDataToUnsave.every(idObj => {
            const match = accessDataList.find(item => item.person_id === idObj.person_id);
            return match && match.email && match.email.trim() !== "";
        });

        if (!allValid) {
            toast.error("Please get the email access for all selected records before moving", {
                autoClose: 2000,
            })
            return;
        }

        let payload = {
            "moduleId": prospectModuleId,
            "log_details": {
                "user": `${currentUserData?.firstName} ${currentUserData?.lastName}`,
                "details": " Created"
            },
            "audit_log": {
                "msg": `Added a Prospects named ${currentUserData?.firstName} ${currentUserData?.lastName}`
            }
        }
        let dataArray = [];
        selectedDataToUnsave.forEach(element => {
            dataArray.push(
                [
                    {
                        "section_name": "Company Details",
                        "section_data": {
                            "Prospect_Owner": {
                                "_id": currentUserData?._id,
                                "name": `${currentUserData?.firstName} ${currentUserData?.lastName}`
                            },
                            "Number_of_Employess": "",
                            "Company_Name": element?.organization?.name,
                            "Location": element?.city,
                            "Company_Website": element?.organization?.website_url,
                            "Industry": ""
                        }
                    },
                    {
                        "section_name": "Contact Details",
                        "section_data": {
                            "table_data": [
                                {
                                    "Auto_Number": "",
                                    "First_Name": element?.first_name,
                                    "Last_Name": element?.last_name,
                                    "Mobile_Number": accessDataList.find((item) => item.person_id === element?.person_id)?.phone || "",
                                    "Email": accessDataList.find((item) => item.person_id === element?.person_id)?.email || "",
                                    "Job_title": element?.title,
                                    "Discount_Type": "amount",
                                    "Email_isPrimary": true
                                }
                            ]
                        }
                    }
                ]
            );
        });
        payload['data'] = dataArray
        dispatch(saveProspectStart({ data: payload }));
    }

    // useEffect(() => {
    //     if (subFormData?.exit) {
    //         setMode('move')
    //         // unsaveFilterData()
    //     }
    // }, [subFormData?.exit]);

    useEffect(() => {
        if (scrapperData?.data) {
            dispatch(getRecentSearchStart())
        }
    }, [scrapperData?.data])
    return (<>
        <Toast />
        <Loader isVisible={scrapperData?.isLoading || subFormData?.isLoading} />
        {/* Header */}
        <div className="container-fluid hstack sticky-top bg-light-subtle border-bottom border-light-subtle py-2">
            <div className="me-auto">
                <span className="fw-semibold fs-5">Digy Navigator</span>
            </div>
            {/* <div className="ms-auto">
                <div className="btn-group">
                    <Dropdown>
                        <Dropdown.Toggle variant="dark" id="research-ai-dropdown"
                            className="d-flex justify-content-between align-items-center px-2 shadow-none">
                            <span className="pe-2">Research with AI</span>
                            <FaChevronDown className="dd-arrow" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="w-100" align='end'>
                            <Dropdown.Item>option 1</Dropdown.Item>
                            <Dropdown.Item>option 2</Dropdown.Item>
                            <Dropdown.Item>option 3</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                        <Dropdown.Toggle variant="light flat-btn"
                            className="d-flex justify-content-between align-items-center px-2 shadow-none me-0">
                            <span className="pe-2">Import</span>
                            <FaChevronDown className="dd-arrow" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="w-100">
                            <Dropdown.Item>option 1</Dropdown.Item>
                            <Dropdown.Item>option 2</Dropdown.Item>
                            <Dropdown.Item>option 3</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div> */}
        </div>
        {/* // Header END // */}
        <div className="content-section">
            {/* Search Settings */}
            <div className="container-fluid search-settings">
                <Row className="align-items-center pt-2">
                    <Col md={4} xl={3} className="hstack gap-2">
                        {/* <Dropdown>
                            <Dropdown.Toggle variant="light flat-btn"
                                className="d-flex justify-content-between align-items-center px-2 shadow-none me-0">
                                <DefaultFilterViewIcon className="me-2" />
                                <span className="pe-2">Default view</span>
                                <FaChevronDown className="dd-arrow" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="w-100">
                                <Dropdown.Item>option 1</Dropdown.Item>
                                <Dropdown.Item>option 2</Dropdown.Item>
                                <Dropdown.Item>option 3</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <div className="search-box border rounded-2 position-relative">
                            <button className="searchbutton bg-white" type="button">
                                <i className="fa-solid fa-magnifying-glass"></i>
                            </button>
                            <input type="search" placeholder="Search" className="searchfield bg-white" name='prospectsMainSearch'
                                value={searchValue} onChange={e => setSearchValue(e.target.value)} />
                        </div> */}
                    </Col>
                    <Col md={8} xl={9} className="hstack gap-2 justify-content-center justify-content-md-end">
                        {/* <Dropdown>
                            <Dropdown.Toggle variant="light flat-btn"
                                className="d-flex justify-content-between align-items-center px-2 shadow-none">
                                <AiOutlineThunderbolt className="me-2" />
                                <span className="pe-2">Create workflow</span>
                                <FaChevronDown className="dd-arrow" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="w-100">
                                <Dropdown.Item>option 1</Dropdown.Item>
                                <Dropdown.Item>option 2</Dropdown.Item>
                                <Dropdown.Item>option 3</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown> */}
                        <button class={`btn btn-light btn-blue me-2 border ${!selectedDataToSave.length && 'd-none'}`} type="button"
                            onClick={() => saveFilterData()}>
                            <IoMdAdd className="me-1" />
                            Save</button>
                        <button class={`btn btn-light btn-blue me-2 border ${!selectedDataToUnsave.length && 'd-none'}`} type="button"
                            onClick={() => { setSavedTableAction('unsave'); setMode('delete'); unsaveFilterData() }}>
                            <FaMinus className="me-1" />
                            Unsave</button>
                        <button class={`btn btn-light btn-blue me-2 border ${!selectedDataToUnsave.length && 'd-none'}`} type="button"
                            onClick={() => { setSavedTableAction('access'); getAccessMobile() }}>
                            <TbPhoneCheck className="me-1" />
                            Access Mobile</button>
                        <button class={`btn btn-light btn-blue me-2 border ${!selectedDataToUnsave.length && 'd-none'}`} type="button"
                            onClick={() => handleMove()} >
                            <LuShare className="me-1" />
                            Move to Prospects</button>
                        {/* <Dropdown>
                            <Dropdown.Toggle variant="light flat-btn"
                                className="with-arrow d-flex justify-content-between align-items-center ps-2 pe-4 shadow-none">
                                <PeopleAutoScoreIcon className="me-2" />
                                <span className="pe-2">People Auto-Score</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="w-100">
                                <Dropdown.Item>option 1</Dropdown.Item>
                                <Dropdown.Item>option 2</Dropdown.Item>
                                <Dropdown.Item>option 3</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Button variant={`${showFilterSection ? 'light-white' : 'secondary'} px-2`} onClick={() => setShowFilterSection(!showFilterSection)}>
                            <PiSlidersHorizontal className="me-2" />
                            <span>{showFilterSection ? 'Hide' : 'Show'} Filters</span>
                        </Button>
                        <Button variant="light flat-btn px-2">
                            <HiOutlineCog6Tooth className="me-2" />
                            <span>Search Settings</span>
                        </Button> */}
                    </Col>
                </Row>
            </div>
            {/* // Search Settings END // */}
            <div className="container-fluid">
                <Row className="setup-card">
                    <div className={`col-2 px-0 border-end ${showFilterSection ? '' : 'd-none'}`}>
                        <Sidebar selectedOption={selectedOption} setSelectedOption={setSelectedOption}
                            setIsShowMatchingContacts={setIsShowMatchingContacts} data={scrapperData?.data}
                            totalCount={scrapperData?.totalCount} setShowFilterData={setShowFilterData}
                            setIsInitial={setIsInitial} filterObj={filterObj} setFilterObj={setFilterObj}
                            suggestionData={scrapperData?.suggestionData} savedData={scrapperData?.savedData}
                            selectedTab={selectedTab} setSelectedtab={setSelectedtab} totalSavedCount={scrapperData?.totalSavedCount}
                            jobSuggestionData={scrapperData?.jobSuggestionData}
                            industrySuggestionData={scrapperData?.industrySuggestionData} />
                    </div>

                    {selectedOption !== 'Contact Name' ?
                        <>
                            {!isShowMatchingContacts ?
                                <>
                                    {selectedOption &&
                                        <div className={`overflow-y-auto 
                                            ${((showFilterSection && selectedItems.length == 0) || (!showFilterSection && selectedItems.length > 0)) && 'col-10' ||
                                            (showFilterSection && selectedItems.length > 0) && 'col-8' ||
                                            (!showFilterSection && selectedItems.length == 0) && 'col-12'
                                            }`}
                                            style={{ height: 'calc(100vh - 14vh)' }}>
                                            <Filters
                                                selectedOption={selectedOption}
                                                selectedItems={selectedItems}
                                                setSelectedItems={setSelectedItems}
                                            />
                                        </div>
                                    }
                                    {(selectedOption && selectedItems.length > 0) &&
                                        <div className="col-2 border-start" style={{ position: 'relative', height: 'calc(100vh - 18.8vh)' }}>
                                            <SelectedFilters
                                                selectedOption={selectedOption}
                                                selectedItems={selectedItems}
                                                handleRemove={handleRemove}
                                                handleClearAll={handleClearAll}
                                                setIsShowMatchingContacts={setIsShowMatchingContacts}
                                            />
                                        </div>
                                    }
                                </>
                                :
                                <div className={`overflow-y-auto ${showFilterSection ? 'col-10' : 'col-12'}`} style={{ height: 'calc(100vh - 13.2vh)' }}>
                                    {selectedTab === 'saved' ?
                                        <SavedTableData savedData={scrapperData?.savedData}
                                            setSelectedDataToUnsave={setSelectedDataToUnsave}
                                            selectedDataToUnsave={selectedDataToUnsave}
                                            currentPageS={currentPageS} setCurrentPageS={setCurrentPageS}
                                            pageSizeS={pageSizeS} setPageSizeS={setPageSizeS}
                                            setPaginationActivateS={setPaginationActivateS}
                                            totalSavedCount={scrapperData?.totalSavedCount}
                                            accessDataList={accessDataList}
                                            error={scrapperData?.error}
                                        />
                                        : <>
                                            {isInitial ?
                                                <>
                                                    <QuickFilters data={filterObj} setFilterObj={setFilterObj} setIsInitial={setIsInitial}
                                                        currentPage={currentPage} pageSize={pageSize} />
                                                    <RecentSearchData recentSavedData={scrapperData?.recentSavedData}
                                                        recentSearchedData={scrapperData?.recentSearchedData}
                                                        setSelectedtab={setSelectedtab}
                                                        setIsInitial={setIsInitial}
                                                        currentPage={currentPage} pageSize={pageSize} />
                                                </>
                                                :
                                                <CompanyTableData
                                                    error={scrapperData?.error}
                                                    selectedOption={selectedOption}
                                                    _data={scrapperData?.data}
                                                    _totalCount={scrapperData?.totalCount}
                                                    showFilterData={showFilterData}
                                                    searchValue={searchValue}
                                                    currentPage={currentPage}
                                                    pageSize={pageSize}
                                                    setCurrentPage={setCurrentPage}
                                                    setPageSize={setPageSize}
                                                    setPaginationActivate={setPaginationActivate}
                                                    setSelectedDataToSave={setSelectedDataToSave}
                                                    selectedDataToSave={selectedDataToSave}
                                                />
                                            }
                                        </>
                                    }
                                </div>
                            }
                        </>
                        :
                        <div className="col-10 overflow-y-auto" style={{ height: 'calc(100vh - 18.8vh)' }}>
                            <ContactTableData
                                selectedOption={selectedOption}
                            />
                        </div>
                    }
                </Row>
            </div>
        </div>
    </>);
}
export default DataVault;